<template>
  <div>
    <h1>Overview</h1>
    <div class="flex center v_center column">
      <h2 style="margin-top: 15px;">Welcome to BackOffice</h2>
      <h3>Use the menu on your left to navigate around</h3>
    </div>
  </div>
</template>

<script>
  import MainLayout from "../layouts/MainLayout"
  export default {
    data() {
      return {}
    },
    components: {
      MainLayout
    },

  }
</script>
